var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { Language } from '../types/Language';
import LanguageContext from '../contexts/LanguageContext';
var LanguageProvider = function (_a) {
  var children = _a.children;
  var _b = useState(Language.ENGLISH),
    language = _b[0],
    setLanguage = _b[1];
  var value = {
    language: language,
    setLanguage: setLanguage
  };
  return _jsx(LanguageContext.Provider, __assign({
    value: value
  }, {
    children: children
  }));
};
export default LanguageProvider;